export default __webpack_public_path__ + "static/media/7minfitness@2x.4a0e7ab5.jpg";